import React, {Component} from 'react';
import {connect} from 'react-redux';

import SkillsForm from '../../../../components/Forms/SkillsForm/SkillsForm.jsx';

import {prepareFreelanceBeforeSubmit} from '../../../../../shared/services/freelanceService';
import {prepareUserBeforeSubmit} from '../../../../../shared/services/userService';

import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

class Skills extends Component {
  onUploadSuccess = (image) => {
    this.props.refresh({
      user: {
        ...this.props.user,
        image,
      },
      freelance: {
        ...this.props.freelance,
        image,
      },
    });
  };

  submit = (values) => {
    this.props.submit({
      user: prepareUserBeforeSubmit(values.user),
      freelance: this.prepareFreelance(values.freelance)
    });
  };

  prepareFreelance = (freelance) => {
    return {
      ...prepareFreelanceBeforeSubmit(freelance),
    }
  };

  expandSecteurs = (freelance) => {
    const selectedSecteursIds = freelance.secteurs.map(secteur => secteur.id);

    return this.props.secteurs.reduce((acc, secteur) => {
      secteur.checked = selectedSecteursIds.includes(secteur.id);
      acc.push(secteur);
      return acc;
    }, []);
  };

  render() {
    return (
      <FreelancePage className="p-5">
        <div className="step-general-pres">
          {this.props.user && this.props.freelance &&
          <div>
            <SkillsForm
              isAdmin={this.props.isAdmin}
              enableReinitialize={true}
              onSubmit={this.submit}
              initialValues={{
                user: this.props.user,
                freelance: {...this.props.freelance}
              }}
              onSubmitSuccess={this.props.onFormSuccess}/>
          </div>
          }
        </div>
      </FreelancePage>
    );
  }
}

export default connect(
  state => ({
    secteurs: state.secteurs.secteurs
  })
)(Skills);
